
import { mdiClose } from "@mdi/js";

export default {
  props: {
    incallRates: {
      type: Array,
      default: () => [],
    },
    outcallRates: {
      type: Array,
      default: () => [],
    },
    onlineRates: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      mdiClose,
      isOpen: false,
      modalHeaderText: "Companionship rates",
    };
  },

  computed: {
    dialogProps() {
      const props = {
        attach: "#app",
      };

      if (
        this.$device.isMobile ||
        (typeof window !== "undefined" && window.innerWidth < 710)
      ) {
        props.fullscreen = true;
        props.scrollable = true;
        props.transition = "dialog-bottom-transition";
        props.contentClass = "rates-modal__dialog";
      } else {
        props.maxWidth = "860";
      }

      return props;
    },
  },

  methods: {
    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },

    convertPriceTitle(title) {
      const match = title.match(/^(\d+)([HNM])$/);

      if (match) {
        const count = match[1];
        const type = match[2];

        let key = "";
        switch (type) {
          case "H":
            key = "hour";
            break;
          case "N":
            key = "night";
            break;
          case "M":
            key = "minute";
            break;
        }
        return `${count} ${this.$tc(`${key}`, count)}`;
      }
      return title;
    },
  },
};
